<template>
    <v-container fluid>
        <div class="tables-basic">
            <h1 class="page-title mt-10 mb-6">Zgłoszenie</h1>

            <ErrorSubscription :isCustomerActive="isCustomerActive()" />

            <v-row v-if="isCustomerActive()">
                <v-col cols="6">
                    <v-card>
                        <v-card-title class="pa-6 pb-3">
                            <p>Informacje podstawowe zgłoszenia</p>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text class="pa-3 pb-2" center>Identyfikator zgłoszenia: <span class="text-bold">{{signal.identifier}}</span></v-card-text>
                        <v-card-text class="pa-3 pb-2">Data wpływu: <span class="text-bold">{{signal.datetime}}</span></v-card-text>
                        <v-card-text class="pa-3 pb-2">Dni od zgłoszenia: <span class="text-bold">{{signal.days}}</span></v-card-text>
                        <v-card-text class="pa-3 pb-2">Etykieta: <span class="text-bold">{{signal.title}}</span></v-card-text>
                        <v-card-text class="pa-3 pb-2">Status: <span class="text-bold">{{signal.statusForReport}}</span></v-card-text>
                        <v-card-text class="pa-3 pb-2">Data zakończenia sprawy: <span class="text-bold">{{signal.archiveTime != null ? signal.archiveTime : '-'}}</span></v-card-text>
                        <v-card-text class="pa-0 pb-6">
                            <v-col class="d-flex" sm="6" cols="12">
                                Kategoria:
                                <v-select v-model="selectedCategory" :items="cat" item-text="catName" item-value="catId" @change="moveSygnalToCategory($event)" dense class="mgr-l-10"></v-select>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-card>
                        <v-card-title class="pa-2 pb-0">
                            <p>Akcje dla zgłoszenia</p>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showNotes()">
                                    <v-icon color="orange">mdi-pen</v-icon><div>Działania następcze</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showPropertyDamageInfo()">
                                    <v-icon color="red">mdi-bank-outline</v-icon><div>Informacje o szkodzie majątkowej</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showSignal()" :disabled="decryptSignal == true">
                                    <v-icon color="blue">mdi-key-variant</v-icon><div>Zobacz zgłoszenie</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showPrivateFiles()">
                                    <v-icon color="green">mdi-file-import</v-icon><div>Załączniki prywatne</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text v-if="canExternalSend == true" class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showExternalList()">
                                    <v-icon color="purple">mdi-email-fast-outline</v-icon><div>Lista organów zewnętrznych</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center">
                                <v-btn icon @click="showLogsForSignal()">
                                    <v-icon color="silver">mdi-account-search</v-icon><div>Pokaż logi dla zgłoszenia</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-0">
                            <v-card class="text-center" v-if="canArchivize">
                                <v-btn icon @click="addToArchiv()" :disabled="signal.status == 3 || signal.status == 1">
                                    <v-icon color="brown">mdi-archive</v-icon><div>Zarchiwizuj Zgłoszenie</div>
                                </v-btn>
                            </v-card>
                            <v-card class="text-center" v-else>
                                <v-card-text class="pa-3 pb-1"><span class="text-bold">BRAK UPRAWNIEŃ DO ARCHIWIZACJI</span></v-card-text>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-2" v-if="signal.status !== 3 && signal.canResponse">
                            <v-card class="text-center">
                                <v-btn icon @click="showSendMessageBox()">
                                    <v-icon color="green">mdi-email-outline</v-icon><div>ODPOWIEDZ SYGNALIŚCIE</div>
                                </v-btn>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-3 pb-2" v-else>
                            <v-card class="text-center">
                                <v-card-text v-if="signal.status == 3" class="pa-3 pb-1"><span class="text-bold">ZGŁOSZENIE ZOSTAŁO ZAMKNIĘTE</span></v-card-text>
                                <v-card-text v-if="!signal.canResponse" class="pa-3 pb-1"><span class="text-bold">BRAK UPRAWNIEŃ DO ODPOWIADANIA SYGNALIŚCIE</span></v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="showExternalListFlag == true && isCustomerActive() && canExternalSend == true">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-1">
                            <p>Lista odbiorców organów zewnętrznych którym przekazano zgłoszenie</p>
                            <v-spacer></v-spacer>
                            <v-btn @click="closeSendExternal()" class="mgr-l-50">
                               <div>Zamknij</div>
                            </v-btn>
                        </v-card-title>
                        <div v-if="externalList.length > 0">
                            <v-card-text class="pa-6 pb-6">

                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left pa-6">Lp.</th>
                                                <th class="text-left pa-6">Nazwa</th>
                                                <th class="text-left">Odbiorca</th>
                                                <th class="text-left">DW</th>
                                                <th class="text-left">Data wysyłki</th>
                                                <th class="text-left">Data dostarczenia</th>
                                                <th class="text-left">Dołączono pliki</th>
                                                <th class="text-left">Status</th>
                                                <th class="text-left"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in externalList" :key="item.id">
                                                <td class="pa-6">{{ index + 1 }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.emailTo }}</td>
                                                <td>{{ item.emailCc }}</td>
                                                <td>{{ item.sendDate }}</td>
                                                <td>{{ item.deliveredDate }}</td>
                                                <td>{{item.withFiles == true ? 'TAK' : 'NIE' }}</td>
                                                <td>{{item.statusDescription}}</td>
                                                <td>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn text @click="refreshStatus(item)" v-on="on">
                                                                <v-icon color="green">mdi-refresh</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>ODŚWIEŹ STATUS</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                            </v-card-text>
                        </div>
                        <div v-else>
                            <v-card-text class="pa-6 pb-6">
                                <div>
                                    Brak danych
                                </div><v-spacer></v-spacer>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="showPrivateFilesFlag == true && isCustomerActive()">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-1">
                            <p>Załączniki prywatne</p>
                            <v-spacer></v-spacer>
                            <v-btn @click="addPrivateFile()" class="mgr-l-50">
                                <v-icon color="green">mdi-file-import</v-icon><div>DODAJ załącznik prywatny</div>
                            </v-btn>
                        </v-card-title>
                        <v-progress-circular v-if="showLoader" class="prog-bar-mgr" :width="4" color="green" indeterminate></v-progress-circular>
                        <div v-if="privateFiles.length > 0">
                            <v-card-text class="pa-6 pb-6">
                                <span v-for="item in privateFiles" :key="item.id">
                                    <div>
                                        <v-btn class="btn-file-sinal" @click="getPrivateFile(item)" :disable="getPrivateFileInProgress == true"> {{item.name}} </v-btn>
                                        <v-btn class="btn-delete-file" @click="deletePrivateFile(item)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                                    </div>
                                </span>

                            </v-card-text>
                        </div>
                        <div v-else>
                            <v-card-text class="pa-6 pb-6">
                                <div>
                                    Brak załączników prywatnych
                                </div><v-spacer></v-spacer>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="fileshowFlag && isCustomerActive()">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-1">
                            <p>Załączniki dołączone do zgłoszenia (widoczne dla sygnalisty)</p>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <div v-if="signal.files.length > 0">
                            <v-card-text class="pa-6 pb-6">
                                <v-btn class="btn-file-sinal-2" v-for="item in signal.files" :key="item.id" @click="getFile(item)">{{item.name}}</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-text>
                        </div>
                        <div v-else>
                            <v-card-text class="pa-6 pb-6">
                                <div>
                                    Brak załączników
                                </div><v-spacer></v-spacer>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="sendMessageFlag && isCustomerActive()">
                <v-col cols="12">
                    <v-card class="pa-3 pb-3">
                        <v-card-title class="pa-6 pb-1">
                            <p>Wiadomość do sygnalisty</p>
                            <v-spacer></v-spacer>
                            <v-btn @click="hideSendMessageBox()" class="mgr-l-50">Ukryj</v-btn>
                        </v-card-title>
                        <div>
                            <v-card-text class="pa-3 pb-0">
                                <v-textarea v-model="textarea" auto-grow outlined name="input-7-4" label="Treść wiadomości..."></v-textarea>
                            </v-card-text>
                        </div>
                        <v-row>
                            <v-col cols="6">
                                <v-card-text class="pa-2 pb-0">
                                    <v-card class="text-center pa-0 pb-0">
                                        <v-btn icon @click="szyfruj()" :disabled="textarea.length == 0 || showLoaderReplyTosygnalist == true">
                                            <v-progress-circular v-if="showLoaderReplyTosygnalist" class="prog-bar-mgr" :width="4" color="green" indeterminate></v-progress-circular>
                                            <v-icon color="blue">mdi-cube-send</v-icon><div>WYŚLIJ</div>
                                        </v-btn>
                                    </v-card>
                                </v-card-text>
                            </v-col>
                            <v-col cols="6">
                                <v-card-text class="pa-3 pb-0">
                                    <v-card class="text-center pa-0 pb-0">
                                        <v-btn icon @click="addFile()" :disabled="showLoaderReplyTosygnalist == true">
                                            <v-icon color="blue">mdi-file-import</v-icon><div>DODAJ załącznik</div>
                                        </v-btn>
                                    </v-card>
                                </v-card-text>
                            </v-col>
                        </v-row>
                        <div>
                            <v-card-text class="pa-3 pb-0">
                                <v-card-title>Lista załączników</v-card-title>
                                <div v-if="files != null && files.length > 0">
                                    <v-card-text class="pa-2 pb-3" v-for="item in files" :key="item[0].name">
                                        {{item[0].name}} <v-btn icon @click="deleteFile(item)">
                                            <v-icon color="red">mdi-trash-can</v-icon>
                                        </v-btn>
                                    </v-card-text>
                                </div>
                                <div v-else>
                                    <v-card-text>Brak załączników</v-card-text>
                                </div>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="decryptSignal && isCustomerActive()">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-3">
                            <p>Tablica konwersacji</p>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="hide()" v-if="!hideMessages">
                                <v-icon color="red">mdi-eye-off-outline</v-icon><div>Ukryj wiadomości</div>
                            </v-btn>
                            <v-btn icon @click="show()" v-if="hideMessages">
                                <v-icon color="blue">mdi-eye-outline</v-icon><div>pokaż wiadomości</div>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="showFiles()" v-if="!fileshowFlag">
                                <v-icon color="blue">mdi-file-document</v-icon><div>Pokaż Załączniki</div>
                            </v-btn>
                            <v-btn icon @click="hideFiles()" v-if="fileshowFlag">
                                <v-icon color="grey">mdi-file-hidden</v-icon><div>ukryj Załączniki</div>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="downloadSignalPdf()" :disabled="downloadPdfInProgress == true">
                                <v-icon color="green">mdi-download-box</v-icon><div>pobierz zgłoszenie</div>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="openSendExternalModal()" v-if="canExternalSend == true">
                                <v-icon color="purple">mdi-email-fast-outline</v-icon><div>Przekaż zgłoszenie</div>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <div v-if="!hideMessages">
                            <v-card-text class="pa-4 pb-3" v-for="item in messages" :key="item.id">
                                <v-card>
                                    <v-card-title class="pa-3 pb-0 mgr-b-15">
                                        <p class="p-font-size" v-if="item.adminName != null && item.adminName.length > 0">Administrator: {{item.adminName}}</p>
                                        <p class="p-font-size" v-else-if="(item.sygnalistName != null && item.sygnalistName.length > 0) || (item.sygnalistEmail != null && item.sygnalistEmail.length > 0)">Sygnalista: {{item.sygnalistName}} {{item.sygnalistEmail != null && item.sygnalistEmail.length > 0 ? '(e-mail: ' + item.sygnalistEmail + ')' : ''}} {{item.sygnalistPhone != null && item.sygnalistPhone.length > 0 ? '(telefon: ' + item.sygnalistPhone + ')' : ''}}</p>
                                        <p class="p-font-size" v-else>Sygnalista</p>
                                        <p class="p-font-size mgr-l-15">{{item.datetime}}</p>
                                    </v-card-title>
                                    <v-card-text v-for="m in item.msg" :key="m.label" class="pad-t-0">
                                        <div v-if="m.type == 1 || m.type == 2"> {{m.label}}: <b>{{m.value}}</b></div>
                                        <div v-else-if="m.type == 3"> {{m.label}}: <b>{{m.value == 'on' ? 'TAK' : 'NIE'}}</b></div>
                                        <div v-else> {{prepareLabelForSelect(m.label)}}: <b>{{m.value == '' ? 'Brak wyboru' : m.value}}</b></div>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="showNotesModal && isCustomerActive()">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-1">
                            <p>Działania następcze</p>
                            <v-spacer></v-spacer>
                            <v-btn @click="closeModal()" class="mgr-l-50">Ukryj</v-btn>
                        </v-card-title>
                        <div v-if="notes.length > 0">
                            <v-card-text class="pa-4 pb-1" v-for="item in notes" :key="item.id">
                                <v-card>
                                    <v-card-title class="pa-3 pb-0 mgr-b-15">
                                        <p class="p-font-size">{{item.adminName}}</p>
                                        <p class="p-font-size mgr-l-15">{{formatDateToDisplay(item.date)}} {{item.showInReport == true ? '(wpis widoczny w rejestrze zgłoszeń)' : ''}}</p>
                                        <v-spacer></v-spacer>
                                        <v-btn v-if="item.adminId == loggedAdminId" @click="openEditNotesodal(item)" class="mgr-l-50">
                                            <v-icon color="green">mdi-pencil-box-outline</v-icon><div>Edytuj</div>
                                        </v-btn>

                                    </v-card-title>
                                    <v-card-text>
                                        <div>{{item.text}}</div>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </div>
                        <div v-else>
                            <v-card-text>
                                Brak notatek dotyczących działan następczych...
                            </v-card-text>
                        </div>
                        <v-card-text class="pa-4 pb-0 p-font-size">*Działania następcze nie są widoczne dla sygnalisty</v-card-text>
                        <hr />
                        <div>
                            <v-card-title class="pa-3 pb-1">
                                <p>Działania następcze do zgłoszenia</p>

                                <v-spacer></v-spacer>
                                <v-checkbox v-model="showInReport"
                                            label="Pokazuj w rejestrze zgłoszeń"
                                            @change="$v.showInReport.$touch()"
                                            @blur="$v.showInReport.$touch()"></v-checkbox>
                            </v-card-title>
                            <div>
                                <v-card-text class="pa-3 pb-3">
                                    <v-textarea v-model="notesArea" solo auto-grow label="Treść..."></v-textarea>
                                    <div class="text-center">
                                        <v-btn @click="sendNotes()" :disabled="notesArea.length == 0">
                                            <v-icon color="orange">mdi-pencil-box-outline</v-icon><div>DODAJ</div>
                                        </v-btn>
                                    </div>
                                </v-card-text>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="showPropertyDamageInfoModal && isCustomerActive()">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-6 pb-1">
                            <p>Informacje o szkodzie majątkowej</p>
                            <v-spacer></v-spacer>
                            <v-btn @click="closeModal()" class="mgr-l-50">Ukryj</v-btn>
                        </v-card-title>
                        <div v-if="propertyDamageInfos.length > 0">
                            <v-card-text class="pa-4 pb-1" v-for="item in propertyDamageInfos" :key="item.id">
                                <v-card>
                                    <v-card-title class="pa-3 pb-0 mgr-b-15">
                                        <p class="p-font-size">{{item.adminName}}</p>
                                        <p class="p-font-size mgr-l-15">{{formatDateToDisplay(item.date)}} {{item.showInReport == true ? '(wpis widoczny w rejestrze zgłoszeń)' : ''}}</p>
                                        <v-spacer></v-spacer>
                                        <v-btn v-if="item.adminId == loggedAdminId" @click="openEditPropertyDamageModal(item)" class="mgr-l-50">
                                            <v-icon color="green">mdi-pencil-box-outline</v-icon><div>Edytuj</div>
                                        </v-btn>

                                    </v-card-title>
                                    <v-card-text>
                                        <div>{{item.text}}</div>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </div>
                        <div v-else>
                            <v-card-text>
                                Brak notatek dotyczących szkód majątkowych...
                            </v-card-text>
                        </div>
                        <v-card-text class="pa-4 pb-0 p-font-size">*Informacje o szkodzie majątkowej nie są widoczne dla sygnalisty</v-card-text>
                        <hr />
                        <div>
                            <v-card-title class="pa-3 pb-1">
                                <p>Informacje o szkodzie majątkowej do zgłoszenia</p>

                                <v-spacer></v-spacer>
                                <v-checkbox v-model="showInReportPropertyDamage"
                                            label="Pokazuj w rejestrze zgłoszeń"
                                            @change="$v.showInReportPropertyDamage.$touch()"
                                            @blur="$v.showInReportPropertyDamage.$touch()"></v-checkbox>
                            </v-card-title>
                            <div>
                                <v-card-text class="pa-3 pb-3">
                                    <v-textarea v-model="propertyDamageArea" solo auto-grow label="Treść..."></v-textarea>
                                    <div class="text-center">
                                        <v-btn @click="sendPropertyDamageInfo()" :disabled="propertyDamageArea.length == 0">
                                            <v-icon color="orange">mdi-pencil-box-outline</v-icon><div>DODAJ</div>
                                        </v-btn>
                                    </div>
                                </v-card-text>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <EditNoteModal v-show="showNoteModal" @close="closeEditNoteModal" :noteToEdit="noteToEdit" @updateNotes="updateNotes" />
            <EditNoteModal v-show="showDemageModal" @close="closeEditDamageModal" :noteToEdit="damageToEdit" @updateNotes="updatePropertyDamageInfo" />
            <ExternalSendModal v-show="showSendExternalModal" @close="closeSendExternalModal" :externalToSend="externalToSend" @sendExternalSignal="sendSignalToExternalCompany" />
            <LoaderModal v-show="showLoaderModal" :showLoader="showLoaderModal" />

        </div>

    </v-container>
</template>

<script>
    import Service from '@/services/Service'
    import CryptoJS from 'crypto-js'
    import ErrorSubscription from '@/components/Modals/ErrorInfoSubscription.vue'
    import EditNoteModal from '@/components/Modals/EditNoteModal.vue'
    import ExternalSendModal from '@/components/Modals/SendExternalModal.vue'
    import LoaderModal from '@/components/Modals/Loader.vue'
    import pdfMake from 'pdfmake';
    import pdfFonts from 'pdfmake/build/vfs_fonts';
    //import htmlToPdfmake from 'html-to-pdfmake';

export default {
  name: 'Signal',
  components: {
      ErrorSubscription,
      EditNoteModal,
      ExternalSendModal,
      LoaderModal
    },
  data() {
    return {
      showNoteModal: false,
      showDemageModal: false,
      showLoader: false,
      showLoaderReplyTosygnalist: false,
      signal: {},
      noteToEdit: {},
      damageToEdit: {},
      decryptSignal: false,
      hideMessages: false,
      sendMessageFlag: false,
      fileshowFlag: false,
      messages: [],
      textarea: '',
      signalObject: {},
      files: [],
      pk: '',
      pkid: 0,
      catid: 0,
      main: [],
      canArchivize: false,
      showNotesModal: false,
      showPropertyDamageInfoModal: false,
      notes: [],
      propertyDamageInfos: [],
      notesArea: '',
      propertyDamageArea: '',
      showInReport: false,
      showInReportPropertyDamage: false,
      cat: [],
      selectedCategory: {},
      loggedAdminId: 0,
      canExternalSend: false,
      privateFiles: [],
      showPrivateFilesFlag: false,
      showExternalListFlag: false,
      downloadPdfInProgress: false,
      getPrivateFileInProgress: false,
      externalList: [],
      showSendExternalModal: false,
        externalToSend: {},
        showLoaderModal: false,
    }
  },
async mounted() {
    try {

        if (this.isCustomerActive()) {
            this.main = (await Service.getSpecificSignal(this.$route.params.identifier)).data,
                this.signal = this.main.signal,
                this.canArchivize = this.main.canArchivize,
                this.loggedAdminId = this.main.adminId,
                this.selectedCategory = { catName: this.signal.category, catId: this.signal.categoryId },
                this.cat = this.main.categories,
                this.canExternalSend = this.main.canExternalSend,
                this.privateFiles = this.main.signal.privateFiles
        }

    } catch (e) {
        alert(e.response.data);
        if (e.response.status == 401)
            this.$router.push({ name: 'Login' })
        else {
            this.$router.push({ name: 'Dashboard' })
        }
    }
  },
  methods: {
      showPrivateFiles() {
          this.showPrivateFilesFlag = !this.showPrivateFilesFlag;
      },
      closeSendExternal() {
          this.showExternalListFlag = false;
          this.externalList = [];
      },
      async openSendExternalModal() {
          if (this.canExternalSend == false) {
              return;
          }

          try {
              var result = (await Service.getLoggedUserData()).data;
              if (Object.keys(result).length > 0) {
                  const emailBody = `Szanowni Państwo,\n
Na podstawie obowiązujących przepisów oraz procedur związanych z ochroną sygnalistów,
przekazujemy zgłoszenie otrzymane przez ${result.customerName} do dalszego rozpatrzenia przez Państwa jednostkę.\n
Zgłoszenie:
- Numer zgłoszenia: ${this.signal.identifier}
- Data otrzymania: ${this.signal.datetime}
- Dni od zgłoszenia: ${this.signal.days}
- Szczegółowa treść zgłoszenia dołączona jako załącznik PDF\n
Prosimy nie odpowiadać na tego maila, mail wygenerowany automatycznie. W przypadku konieczności prosimy o kontakt na poniższe dane.\n
Dane kontaktowe:
📩 E-mail: ${result.email}
📞 Telefon: ${result.phone}\n
Dziękujemy za podjęcie niezbędnych działań w tej sprawie.\n
Z poważaniem,
${result.name}
${result.customerName}`;

                  this.externalToSend = {
                      withFiles: true,
                      emailTo: "",
                      emailCc: result.email,
                      body: emailBody,
                      name: ""
                  };
                  this.showSendExternalModal = true;
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async sendSignalToExternalCompany(item) {
          if (this.canExternalSend == false) {
              return;
          }

          if (this.hideMessages == true) {
              return;
          }

          if (this.messages == null || this.messages.length <= 0) {
              return;
          }

          try {
              this.showLoaderModal = true;
              const formData = await this.generatePdfBlobAndFormData(item);

              var result = await (Service.sendSignalToExternalCompany(formData, this.signal.id));
              if (result.data == true) {
                  this.externalToSend = {};
                  this.showSendExternalModal = false;
                  this.showLoaderModal = false;
                  await this.showExternalList();
              }
              else {
                  this.showLoaderModal = false;
              }
          } catch (e) {
              this.externalToSend = {};
              this.showSendExternalModal = false;
              this.showLoaderModal = false;
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async generatePdfBlobAndFormData(item) {
          try {
              var docDefinition = await this.generatePdfData();
              pdfMake.vfs = pdfFonts.pdfMake.vfs;
              const pdfDocGenerator = pdfMake.createPdf(docDefinition);

              return new Promise((resolve, reject) => {
                  pdfDocGenerator.getBlob(blob => {
                      try {

                          const pdfFile = new File([blob], `zgloszenie_${this.signal.identifier}.pdf`, { type: "application/pdf" });

                          const formData = new FormData();
                          formData.append("file", pdfFile);
                          formData.append("emailTo", item.emailTo);
                          formData.append("emailCc", item.emailCc);

                          if (item.withFiles == true && this.signal.files.length > 0) {
                              const additionalLine = "W celu pobrania załączników dołączonych do zgłoszenia prosimy kliknąć w link: ###LINK### \n";
                              const marker = "Prosimy nie odpowiadać na tego maila, mail wygenerowany automatycznie.";
                              if (item.body.includes(marker)) {
                                  item.body = item.body.replace(marker, `${additionalLine}${marker}`);
                              }
                              else {
                                  item.body += `\n${additionalLine}`;
                              }
                          }

                          formData.append("body", item.body);
                          formData.append("withFiles", item.withFiles);
                          formData.append("name", item.name);

                          resolve(formData);
                      } catch (error) {
                          reject(error);
                      }
                  });
              });
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async refreshStatus(item) {
          if (this.canExternalSend == false) {
              return;
          }
          
          try {
              var result = (await Service.getExternalSendStatus(item)).data;
              if (result == true) {
                  await this.showExternalList();
              }

          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async showExternalList() {
          if (this.canExternalSend == false) {
              return;
          }
              
          try {
              var result = (await Service.getExternalList(this.signal.id)).data;
              if (Object.keys(result).length > 0) {
                  if (this.externalList == null || this.externalList == undefined)
                      this.externalList = [];

                  this.externalList = result;
              }

              this.showExternalListFlag = true;

          } catch (e) {
              this.showExternalListFlag = false;
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async getBase64Image(url) {
          return new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = 'Anonymous';
              img.src = url;
              img.onload = () => {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.width;
                  canvas.height = img.height;
                  const ctx = canvas.getContext('2d');
                  ctx.drawImage(img, 0, 0);
                  resolve(canvas.toDataURL('image/png')); // Konwersja do Base64
              };
              img.onerror = (error) => reject(error);
          });
      },
      async downloadSignalPdf() {
          try {
              if (this.hideMessages == true) {
                  return;
              }

              if (this.messages == null || this.messages.length <= 0) {
                  return;
              }

              this.downloadPdfInProgress = true;

              var docDefinition = await this.generatePdfData();
              pdfMake.vfs = pdfFonts.pdfMake.vfs;
              pdfMake.createPdf(docDefinition).download("zgloszenie_" + this.signal.identifier + ".pdf");
              
              this.downloadPdfInProgress = false;
          } catch (e) {
              this.downloadPdfInProgress = false;
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async generatePdfData() {
          if (this.hideMessages == true) {
              return;
          }

          if (this.messages == null || this.messages.length <= 0) {
              return;
          }

          try {
              var result = (await Service.checkUserToGetPdf(this.signal.id)).data;
              if (Object.keys(result).length > 0) {

                  var date = new Date().toLocaleDateString();
                  const logoBase64 = await this.getBase64Image(require('@/assets/sygnali_logo_450_black.png'));

                  const messages = this.messages; // Pobranie wiadomości
                  const content = [
                      {
                          text: 'Identyfikator zgłoszenia: ' + this.signal.identifier,
                          style: 'subheader',
                          margin: [0, 15, 0, 3]
                      },
                      {
                          text: 'Data wpływu: ' + this.signal.datetime,
                          style: 'subheader',
                          margin: [0, 3, 0, 15]
                      },
                      {
                          text: 'Tablica konwersacji',
                          alignment: 'center',
                          style: 'normal',
                      }
                  ];

                  // Generowanie treści wiadomości
                  messages.forEach(item => {
                      const messageContent = [];

                      // Nadawca wiadomości (w jednej linii z datą)
                      let sender = "Sygnalista";
                      if (item.adminName && item.adminName.length > 0) {
                          sender = `Administrator: ${item.adminName}`;
                      } else if ((item.sygnalistName && item.sygnalistName.length > 0) || (item.sygnalistEmail && item.sygnalistEmail.length > 0)) {
                          sender = `Sygnalista:`;
                          if (item.sygnalistName && item.sygnalistName.length > 0) {
                              sender += ` ${item.sygnalistName}`;
                          }
                          if (item.sygnalistEmail && item.sygnalistEmail.length > 0) {
                              sender += ` (e-mail: ${item.sygnalistEmail})`;
                          }
                          if (item.sygnalistPhone && item.sygnalistPhone.length > 0) {
                              sender += ` (telefon: ${item.sygnalistPhone})`;
                          }
                      }

                      // Nagłówek wiadomości
                      messageContent.push({
                          text: [
                              { text: sender, bold: true, fontSize: 10 }, // Nadawca pogrubiony
                              { text: " " + item.datetime, bold: false, fontSize: 10 } // Data normalna
                          ],
                          margin: [0, 2, 0, 5]
                      });

                      // Treść wiadomości
                      item.msg.forEach(m => {
                          let messageText = `${m.label}: `;
                          if (m.type == 1 || m.type == 2) {
                              messageText += ` ${m.value}`;
                          } else if (m.type == 3) {
                              messageText += ` ${m.value === 'on' ? 'TAK' : 'NIE'}`;
                          } else {
                              messageText = this.prepareLabelForSelect(m.label) + ":";
                              messageText += ` ${m.value === '' ? 'Brak wyboru' : m.value}`;
                          }

                          messageContent.push({ text: messageText, fontSize: 10, margin: [0, 5, 0, 5] });
                      });

                      // Dodanie wiadomości jako tabeli (z pełnymi ramkami)
                      content.push({
                          table: {
                              widths: ['*'],
                              body: [[
                                  {
                                      stack: messageContent,
                                      margin: [5, 5, 5, 5],
                                      border: [true, true, true, true] // Pełne obramowanie
                                  }
                              ]]
                          },
                          layout: {
                              hLineWidth: function () { return 0.5; }, // Grubość poziomych linii
                              vLineWidth: function () { return 0.5; }, // Grubość pionowych linii
                              hLineColor: function () { return '#CCCCCC'; }, // Kolor poziomych linii
                              vLineColor: function () { return '#CCCCCC'; }  // Kolor pionowych linii
                          },
                          margin: [0, 5, 0, 5]
                      });
                  });

                  // Definicja PDF
                  const docDefinition = {
                      content: content,
                      header: function () {
                          return [
                              {
                                  columns: [
                                      {
                                          image: logoBase64,
                                          width: 60, // Ustalona szerokość logo
                                          alignment: 'left',
                                          margin: [40, 10, 0, 10]
                                      },
                                      {
                                          text: result,
                                          alignment: 'center',
                                          bold: true,
                                          fontSize: 14,
                                          margin: [0, 20, 0, 10],
                                          width: '*' // Tekst zajmie resztę przestrzeni
                                      },
                                      {
                                          text: "", // Pusta kolumna po prawej, równoważy przestrzeń
                                          width: 60 // Taka sama szerokość jak logo
                                      }
                                  ]
                              },
                              {
                                  canvas: [{
                                      type: 'line',
                                      x1: 40,
                                      y1: 0,
                                      x2: 555,
                                      y2: 0,
                                      lineWidth: 1
                                  }]
                              }
                          ];
                      },
                      footer: function (currentPage, pageCount) {
                          return [
                              {
                                  text: date + " | MWC Sp. z o.o. @ Sygnali.pl - Platforma Ochrony Sygnalistów, Strona " + currentPage.toString() + ' z ' + pageCount,
                                  alignment: 'center',
                                  style: ['quote', 'small'],
                                  margin: [0, 20, 0, 20]
                              }
                          ];
                      },
                      pageSize: "A4",
                      pageMargins: [40, 60, 40, 60],
                      styles: {
                          header: {
                              fontSize: 18,
                              bold: true,
                              marginBottom: 5,
                              marginTop: 10
                          },
                          subheader: {
                              fontSize: 10,
                              bold: true,
                          },
                          normal: {
                              fontSize: 10,
                              margin: 10
                          },
                          quote: {
                              italics: true
                          },
                          small: {
                              fontSize: 8
                          }
                      }
                  };

                  return docDefinition;
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async updateNotes(item) {
          try {
              var result = (await Service.updateNotesForSignal(item)).data;
              if (Object.keys(result).length > 0) {
                  if (this.notes == null)
                      this.notes = [];

                  this.notes = result;
                  this.noteToEdit = {};
                  this.showNoteModal = false;
              }

          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async updatePropertyDamageInfo(item) {
          try {
              var result = (await Service.updatePropertyDamageInfoForSignal(item)).data;
              if (Object.keys(result).length > 0) {
                  if (this.propertyDamageInfos == null)
                      this.propertyDamageInfos = [];

                  this.propertyDamageInfos = result;
                  this.damageToEdit = {};
                  this.showDemageModal = false;
              }

          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      closeEditNoteModal() {
          this.noteToEdit = {};
          this.showNoteModal = false;
      },
      closeEditDamageModal() {
          this.damageToEdit = {};
          this.showDemageModal = false;
      },
      closeSendExternalModal() {
          this.externalToSend = {};
          this.showSendExternalModal = false;
      },
      openEditNotesodal(item) {
          this.noteToEdit = item;
          this.showNoteModal = true;
      },
      openEditPropertyDamageModal(item) {
          this.damageToEdit = item;
          this.showDemageModal = true;
      },
      isCustomerActive() {
          return this.$store.state.admin.customerIsActive;
      },
      showLogsForSignal() {
          localStorage["sygnalIdForLogs"] = JSON.stringify({ sygnalid: this.signal.id });
          this.$router.push({ name: 'Logs' });
      },
      formatDateToDisplay(value) {
          var date = new Date(value)
          var d = date.toLocaleString('default', {
              year: 'numeric',
              month: 'long',
              weekday: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric'
          });

          return d;
      },
      async moveSygnalToCategory(event) {
          try {
              var n = '';
              var c = this.cat.findIndex(x => x.catId == event);
              if (c != -1)
                  n = this.cat[c].catName;

              if (confirm('Czy na pewno przenieść zgłoszenie do kategorii: ' + n + '?')) {
                  var temp = {
                      catId: event,
                      catName: n,
                      messageId: this.signal.id,
                      ip: this.$store.state.ip
                  };

                  var result = (await Service.moveSygnalToNewCategory(temp)).data;
                  if (Object.keys(result).length > 0) {
                      this.selectedCategory = { catName: result.catName, catId: result.catId };
                      this.signal.category = result.catName;
                      this.signal.categoryId = result.catId;
                  }
              } else {
                  this.selectedCategory = { catName: this.signal.category, catId: this.signal.categoryId };
                  return;
              }
          } catch (e) {
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async sendNotes() {
          try {
              var temp = {
                  messageId: this.signal.id,
                  text: this.notesArea,
                  ip: this.$store.state.ip,
                  showInReport: this.showInReport
              }

              var result = (await Service.addNotesForSignal(temp)).data;
              if (Object.keys(result).length > 0) {
                  if (this.notes == null)
                      this.notes = [];

                  this.notes.push(result);
                  this.notesArea = '';
                  this.showInReport = false;
              }
              
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async sendPropertyDamageInfo() {
          try {
              var temp = {
                  messageId: this.signal.id,
                  text: this.propertyDamageArea,
                  ip: this.$store.state.ip,
                  showInReport: this.showInReportPropertyDamage
              }

              var result = (await Service.addPropertyDamageInfoForSignal(temp)).data;
              if (Object.keys(result).length > 0) {
                  if (this.propertyDamageInfos == null)
                      this.propertyDamageInfos = [];

                  this.propertyDamageInfos.push(result);
                  this.propertyDamageArea = '';
                  this.showInReportPropertyDamage = false;
              }

          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      closeModal() {
          this.showNotesModal = false;
          this.showPropertyDamageInfoModal = false;
          this.notes = [];
          this.propertyDamageInfos = [];
          this.notesArea = '';
          this.propertyDamageArea = '';
          this.showInReport = false;
          this.showInReportPropertyDamage = false;
      },
      async showNotes() {
          try {
                var id = this.signal.id;
                var result = (await Service.showNotesForSignal(id)).data;
              if (Object.keys(result).length > 0) {
                  this.notes = result;
              }
              this.showNotesModal = true;
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async showPropertyDamageInfo() {
          try {
              var id = this.signal.id;
              var result = (await Service.showPropertyDamageInfoForSignal(id)).data;
              if (Object.keys(result).length > 0) {
                  this.propertyDamageInfos = result;
              }
              this.showPropertyDamageInfoModal = true;
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      prepareLabelForSelect(item) {
          return item.split('|')[0];
      },
      right(str, chr) {
          return str.slice(str.length - chr, str.length);
      },
      b64decode(x) {
          var result = decodeURIComponent(escape(window.atob(x)));
          return result;
      },
      b64encode(x) {
          var result = btoa(x);
          return result;
      },
      async szyfruj() {
          try {
              this.showLoaderReplyTosygnalist = true;
              var b64 = '';

              var result = (await Service.getSygnaliPublicKey()).data;
              if ((Object.keys(result).length > 0)) {
                  this.pk = result.key;
                  this.pkid = result.id;
                  var toencrypt = this.textarea;
                  var c = CryptoJS.AES.encrypt(toencrypt, this.pk).toString();
                  var w = [{ name: "reply_encrypted", value: c }];
                  var w2 = JSON.stringify(w);
                  b64 = this.b64encode(w2);
                  setTimeout(() => { this.sendMessage(b64); }, 1000);
              }
              else {
                  alert("Błąd podczas pobierania klucza zgłoszenia");
                  this.showLoaderReplyTosygnalist = false;
              }
          } catch (e) {
              this.showLoaderReplyTosygnalist = false;
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      odszyfruj(k, s, result)
      {
          try {
              this.messages = [];
              if (k != "0") {
                  var x = this.decrypt(k, s);
                  const arr = JSON.parse(x);
                  var tempArr = [];
                  for (var i = 0; i < arr.length; i++) {
                      var tempId = arr[i].name.split("&")[0];
                      var type = parseInt(arr[i].name.split("&").pop().split("#")[0]);

                      //tymczasowo
                      if (tempId.includes("_decrypted"))
                          tempId = "Pole";

                      var temp = {
                          label: tempId,
                          value: arr[i].value,
                          type: type
                      }

                      tempArr.push(temp);
                  }
                  
                  if (this.selectedCategory.catName.toLowerCase() === "zgłoszenia zewnętrzne") {
                      var tempRequire = tempArr.find(x => x.label.includes("Żądanie wydania zaświadczenia o podleganiu ochronie (art. 38 ustawy)"));

                      if (tempRequire === undefined) {
                          var temp1 = {
                              label: "Żądanie wydania zaświadczenia o podleganiu ochronie (art. 38 ustawy)",
                              value: "off",
                              type: 3
                          };

                          tempArr.push(temp1);
                      }
                  }

                  var msg = {
                      adminName: result[0].adminName,
                      sygnalistName: result[0].sygnalistName,
                      sygnalistEmail: result[0].sygnalistEmail,
                      sygnalistPhone: result[0].sygnalistPhone,
                      datetime: result[0].datetime,
                      msg: tempArr
                  }

                  this.messages.push(msg);
              } else {
                  var temparr3 = [];
                  var text = '';
                  if (result[0].type == 2)
                      text = 'Zgłoszenie telefoniczne';
                  else if (result[0].type == 3)
                      text = 'Zgłoszenie email';
                  else
                      text = 'Zgłoszenie';

                  var ob = { label: text, type: 1, value: result[0].msg };
                  temparr3.push(ob);

                  var phoneMsg = {
                      adminName: result[0].adminName,
                      sygnalistName: result[0].sygnalistName,
                      sygnalistEmail: result[0].sygnalistEmail,
                      sygnalistPhone: result[0].sygnalistPhone,
                      datetime: result[0].datetime,
                      msg: temparr3
                  };
                  this.messages.push(phoneMsg);
              }

              // odszywrowanie reszty wiadomości 
              for (var j = 1; j < result.length; j++) {
                  var x2 = this.decrypt(result[j].pkid, result[j].msg);
                  const arr = JSON.parse(x2);
                  var temparr2 = [];
                  var obj = {
                      label: 'Odpowiedź',
                      value: arr[0].value,
                      type: 1
                  }
                  temparr2.push(obj);
                  var msg2 = {
                      adminName: result[j].adminName,
                      sygnalistName: result[j].sygnalistName,
                      sygnalistEmail: result[j].sygnalistEmail,
                      sygnalistPhone: result[j].sygnalistPhone,
                      datetime: result[j].datetime,
                      msg: temparr2
                  }
                  this.messages.push(msg2);
              }
          } catch (e) {
              console.log(e)
          }
          
      },
      decrypt(key, message) {
          var m = this.b64decode(message);
          const arr = JSON.parse(m);
          for (var item of arr) {
              var n = item.name;
              var v = item.value;
              if (this.right(n, 10) == '_encrypted' && v != '') {
                  var bytes = CryptoJS.AES.decrypt(v, key);
                  var result = bytes.toString(CryptoJS.enc.Utf8);
                  item.value = result;
                  item.name = item.name.replace("_encrypted", "_decrypted")
              }
          }
          return JSON.stringify(arr)
      },
      async addToArchiv() {
          try {
              if (confirm('Czy na pewno przenieść zgłoszenie o identyfikatorze: ' + this.signal.identifier + ' do archiwum?')) {
                  var temp = {
                      ip: this.$store.state.ip,
                      id: this.signal.id
                  }

                  var result = (await Service.addToArchive(temp));
                  if (result.status == 200) {
                      this.signal.statusForReport = "Archiwalne";
                      this.signal.status = 3;
                      this.signal.archiveTime = result.data;
                  }
              } else {
                  return;
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async showSignal() {
          try {
              var temp = {
                  ip: this.$store.state.ip,
                  id: this.signal.id
              }

              var result = (await Service.showMessages(temp)).data;
              if (Object.keys(result).length > 0) {
                  this.decryptSignal = true;
                  this.odszyfruj(result[0].pkid, result[0].msg, result);
                  this.catid = result[0].categoryId;
                  this.signal.statusForReport = result[0].statusForReport;
                  this.signal.status = result[0].status;
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
    },
    hide() {
          this.hideMessages = true;
      },
      show() {
          this.hideMessages = false;
      },
      showSendMessageBox(){
          this.sendMessageFlag = true;
      },
      hideSendMessageBox() {
          this.textarea = '';
          this.files = [];
          this.sendMessageFlag = false;
      },
      async sendMessage(b64) {
          try {
              var temp = {
                  identifier: this.signal.identifier,
                  msg: b64,
                  pkid: parseInt(this.pkid),
                  catId: this.catid,
                  ip: this.$store.state.ip
              };

              var result = (await Service.sendReply(temp)).data;
              if (Object.keys(result).length > 0) {
                  var temparr2 = [];
                  var obj = {
                      label: 'Odpowiedź',
                      value: this.textarea,
                      type: 1
                  }
                  temparr2.push(obj);
                  var msg2 = {
                      adminName: result.adminName,
                      sygnalistName: result.sygnalistName,
                      sygnalistEmail: result.sygnalistEmail,
                      datetime: result.datetime,
                      msg: temparr2
                  }
                  this.messages.push(msg2);

                  this.textarea = '';
                  this.sendMessageFlag = false;
                  this.pk = '';
                  this.pkid = 0;
                  this.catid = 0;

                  if (this.files.length > 0) {
                      let formData = new FormData();
                      for (var i = 0; i < this.files.length; i++) {
                          let file = this.files[i][0];
                          formData.append('files[' + i + ']', file);
                      }
                      var res = (await Service.saveFileForSignalByAdmin(result.identifier, formData)).data;
                      if (Object.keys(res).length > 0) {
                          if (this.signal.files == null)
                              this.signal.files = [];

                          for (var j = 0; j < res.length; j++) {
                              this.signal.files.push(res[j]);
                          }

                          this.files = [];
                      }
                  }
              }
          } catch (e) {
              this.files = [];
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
          finally {
              this.showLoaderReplyTosygnalist = false;
          }
      },
      showFiles() {
          this.fileshowFlag = true;
      },
      hideFiles() {
          this.fileshowFlag = false;
      },
      async getFile(item) {
          try {
              var id = this.signal.identifier;
              var temp = {
                  identifier: id,
                  fileId: item.id
              };

              var result = (await Service.downloadFile(temp));

              if (result.status == 200) {
                  const contentType = result.headers['content-type'];
                  var a = document.createElement('a');
                  var blob = new Blob([result.data], { 'type': contentType });
                  a.href = window.URL.createObjectURL(blob);
                  a.download = item.name;
                  a.click();
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async getPrivateFile(item) {
          try {
              var id = this.signal.identifier;
              var temp = {
                  identifier: id,
                  fileId: item.id
              };
              this.getPrivateFileInProgress = true;
              var result = (await Service.downloadPrivateFile(temp));

              if (result.status == 200) {
                  const contentType = result.headers['content-type'];
                  var a = document.createElement('a');
                  var blob = new Blob([result.data], { 'type': contentType });
                  a.href = window.URL.createObjectURL(blob);
                  a.download = item.name;
                  a.click();
              }

              this.getPrivateFileInProgress = false;

          } catch (e) {
              this.getPrivateFileInProgress = false;
              alert(e.response.status + " - " + e.response.data.toString());
              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      async checkIsMsgType(file) {
          return new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = function (event) {
                  const arr = new Uint8Array(event.target.result).subarray(0, 8);
                  let header = "";
                  for (let i = 0; i < arr.length; i++) {
                      header += arr[i].toString(16);
                  }

                  // Sprawdzenie magic bytes dla .msg (OLE2 Compound File)
                  if (header.startsWith("d0cf11e0a1b11ae1")) {
                      resolve("application/vnd.ms-outlook");
                  } else {
                      resolve("unknown");
                  }
              };
              reader.readAsArrayBuffer(file.slice(0, 8));
          });
      },
      async checkMimeType(file) {
          const acceptedMimeTypes = [
              "application/pdf",
              "image/jpeg",
              "image/jpg",
              "image/png",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
              "application/msword", // .doc
              "text/csv", // .csv
              "application/vnd.ms-excel", // .xls
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
              "text/plain", // .txt
              "audio/mpeg", // .mp3
              "audio/x-m4a", // .m4a
              "application/vnd.ms-outlook", // .msg (Outlook email files)
              "application/zip", // ZIP
              "application/x-zip-compressed", // ZIP w Windows
              "application/x-compressed", //  ZIP
              "application/x-7z-compressed",
              "application/x-7z"
          ];

          var type_after_check_msg = file.type;

          if (file.name.toLowerCase().endsWith(".msg") && file.type.length == 0) {
              type_after_check_msg = await this.checkIsMsgType(file)
          }

          if (!acceptedMimeTypes.includes(type_after_check_msg)) {
              return false;
          } else {
              return true;
          }
      },
      async addFile() {
          let input = document.createElement('input');
          input.type = 'file';
          input.accept = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' +
              ',.pdf,.png,.jpg,.jpeg' +
              ',.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel' +
              ',.csv,text/csv' +
              ',audio/mpeg,audio/x-m4a' +
              ',.msg' +
              ',.zip,application/zip' +
              ',.7z,application/x-7z-compressed';
          input.multiple = false;
          input.click();
          input.addEventListener('change', async (event) => {
              if (event.target.files[0].size <= 50000000) {

                  const fileElement = event.target.files;

                  if (await this.checkMimeType(fileElement[0])) {
                      if (this.files.length > 0) {
                          for (var i = 0; i < this.files.length; i++) {

                              if (this.files[i][0].name == fileElement[0].name) {
                                  return;
                              }
                          }

                          var tempFileSize = 0;
                          for (var j = 0; j < this.files.length; j++) {
                              tempFileSize += this.files[j][0].size;
                          }
                          tempFileSize += fileElement[0].size;
                          if (tempFileSize >= 30000000) {
                              alert("Zbyt duży rozmiar pliku! Suma załączników nie może przekraczać 50MB");
                              return;
                          }

                          this.files.push(fileElement);
                      }
                      else {
                          this.files.push(fileElement);
                      }
                  }
                  else {
                      alert("Nieobsługiwany typ pliku. Pliki obsługiwane to: DOC,DOCX,PDF,JPG,JPEG,PNG,XLS,XLSX,CSV,MP3,M4A,MSG,ZIP,7Z")
                  }
              }
              else
              {
                  alert("Zbyt duży rozmiar pliku! Suma załączników nie może przekraczać 50MB");
              }
          });
      },
      async addPrivateFile() {
          let input = document.createElement('input');
          input.type = 'file';
          input.accept = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' +
              ',.pdf,.png,.jpg,.jpeg' +
              ',.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel' +
              ',.csv,text/csv' +
              ',audio/mpeg,audio/x-m4a' +
              ',.msg' +
              ',.zip,application/zip' +
              ',.7z,application/x-7z-compressed';

          input.multiple = false;
          input.click();
          input.addEventListener('change', async (event) => {
              if (event.target.files[0].size <= 50000000) {

                  const fileElement = event.target.files;

                  if (await this.checkMimeType(fileElement[0])) {
                      await this.saveElement(this.signal.identifier, fileElement);
                  }
                  else {
                      alert("Nieobsługiwany typ pliku. Pliki obsługiwane to: DOC,DOCX,PDF,JPG,JPEG,PNG,XLS,XLSX,CSV,MP3,M4A,MSG,ZIP,7Z")
                      return;
                  }
              } else {
                  alert("Zbyt duży rozmiar pliku! Suma załączników nie może przekraczać 50MB");
                  return;
              }
          });
      },
      async saveElement(id, files) {
          try {
              this.showLoader = true;
              let formData = new FormData();
              for (var i = 0; i < files.length; i++) {
                  let file = files[i];
                  formData.append('files[' + i + ']', file);
              }

              var result = (await Service.savePrivateFileForSignalByAdmin(id, formData)).data;
              if (Object.keys(result).length > 0) {
                  this.privateFiles = result;
              }
          } catch (e) {
              console.log(e)
              alert(e.response.status + " - " + e.response.data.toString());

              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
          finally {
              this.showLoader = false;
          }
      },
      async deletePrivateFile(item) {
          try {
              var result = (await Service.removePrivateFile(this.signal.id, parseInt(item.id)));
              if (result.status == 200) {
                  const index = this.privateFiles.findIndex(x => x.id == item.id);
                  if (index != -1) {
                      this.privateFiles.splice(index, 1);
                  }
              }
          } catch (e) {
              alert(e.response.status + " - " + e.response.data.toString());

              if (e.response.status == 401)
                  this.$router.push({ name: 'Login' })
          }
      },
      deleteFile(item) {
          if (this.files.length > 0) {
              for (var i = 0; i < this.files.length; i++) {
                  if (this.files[i][0].name == item[0].name) {
                      var index = this.files.indexOf(this.files[i])
                      this.files.splice(index, 1);
                  }
              }
          }
      }
  }
}

</script>

<style scope>
    .text-bold {
        font-weight: bold !important;
    }

    .btn-file-sinal {
        margin-left: 15px !important;
        margin-top: 10px !important;
        max-height: 30px !important;
    }

    .btn-file-sinal-2 {
        margin-left: 15px !important;
        margin-top: 10px !important;
    }

    .prog-bar-mgr {
        margin-left: 20px !important;
    }

    .p-font-size {
        font-size: 0.8em !important;
    }

    .mgr-l-15 {
        margin-left: 15px !important;
    }

    .mgr-b-15 {
        margin-bottom: 15px !important;
    }

    .pad-t-0 {
        padding-top: 0px !important;
    }

    .mgr-l-10 {
        margin-left:10px !important;
    }

    .mgr-l-50 {
        margin-left: 50px !important;
    }

    .btn-delete-file {
        margin-top: 10px !important;
        max-height: 30px !important;
    }

</style>
